<app-loading-bar class="app-loading-bar"></app-loading-bar>

<div class="page-wrapper">
  <!-- Sidebar -->
  <app-sidebar-left></app-sidebar-left>

  <!--- Main Content --->
  <div
    [ngClass]="{ closed: this.sidebarsClosed, left: this.sidebarLeftOpen, right: this.sidebarUserOpen }"
    class="active"
    id="content"
  >
    <header class="header">
      <div class="navbar">
        <div class="container header-container d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <dx-button
              (click)="layoutService.toggleLeftSidebar()"
              class="float-start"
              icon="fas fa-bars"
              style="margin-left: -6px"
            ></dx-button>
          </div>
          <div class="logo-header-container">
            <a
              [queryParams]="logoQueryParams"
              class="navbar-brand d-flex"
              routerLink="/feed"
            >
              <i class="logo-header"></i>
            </a>
          </div>
          <dx-button
            (click)="layoutService.toggleUserSidebar()"
            [template]="'buttonTemplate'"
            class="user-icon float-end"
            icon="fas fa-user"
          >
            <div *dxTemplate="let buttonData of 'buttonTemplate'">
              <i
                class="fas fa-user"
                style="font-size: 24px"
              ></i>
            </div>
          </dx-button>
        </div>
      </div>
    </header>

    <main>
      <div id="main-page-wrapper">
        <div id="main-page">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>

    <app-footer></app-footer>
    <app-bottom-navs></app-bottom-navs>
  </div>
  <app-sidebar-user></app-sidebar-user>
</div>

<div
  (click)="onOverlayClick()"
  [ngClass]="{ active: this.anySidebarOpen }"
  class="sidebar-overlay"
></div>

@if ((layoutService.isActionSheetShown | async) && (vm$ | async); as vm) {
  <dx-action-sheet
    [items]="vm.items"
    [title]="vm.title"
    [cancelText]="vm.cancelText"
    [target]="vm.target"
    [usePopover]="vm.usePopover"
    [width]="vm.width"
    [showCancelButton]="true"
    [showTitle]="true"
    [visible]="true"
    (onCancelClick)="handleCancel()"
    (onItemClick)="handleItemClick($event)"
    (visibleChange)="handleVisibleChange($event)"
  >
    itemTemplate="item" >
    <div *dxTemplate="let item of 'item'">
      @if (item.text) {
        <div>{{ item.text }}</div>
      }
      @if (item.id) {
        <dx-button
          [type]="item.default ? 'default' : 'normal'"
          class="action-sheet-button"
          stylingMode="contained"
        >
          {{ item.name }}
        </dx-button>
      }
    </div>
  </dx-action-sheet>
}

<app-popup
  (visibleChange)="this.layoutService.isReportDialogShown.next($event)"
  [title]="'reportContent.title' | translate"
  [visible]="(this.layoutService.isReportDialogShown | async)!"
>
  <app-content-report (closeContentReport)="this.layoutService.isReportDialogShown.next(false)"></app-content-report>
</app-popup>
